export const isGettyClient = (): boolean => (
  BFG.getty_client === 'true'
);

export const getAssetLibraryTitle = (): string => (
  isGettyClient() ? bfTranslate('Library') : bfTranslate('Brandfolder')
);

export const getAssetLibraryTitlePlural = (): string => (
  isGettyClient() ? bfTranslate('Libraries') : bfTranslate('Brandfolders')
);